module.exports = __webpack_public_path__ + "img/chang-tien-wei-1.ed3296c9.jpeg";